<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        مساعده ها
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <VDataTable2
                                    dense
                                    hide-default-footer
                                    height="400"
                                    fixed-header
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items-per-page="1000"
                                        :items="items"
                                >
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
                                            <v-icon small color="warning">mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn title="حذف" @click="delete_item_dialog(item)" outlined small
                                               color="error">
                                            <v-icon small color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.price="{ item }">
                                        {{get_currency(item.price)}}
                                    </template>

                                </VDataTable2>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن مساعده
                    </v-card-title>
                    <v-card-text>

                        <v-row form class="form-group">
                            <label>
                                کامیون
                            </label>
                            <div dir="rtl">
                                <treeselect
                                        :matchKeys="['code']"

                                        v-model="model.selected_truck"
                                        :cacheOptions="false"
                                        :options="trucks"
                                        placeholder="جستجو کامیون"
                                        :normalizer="normalizer_truck"
                                />
                            </div>
                        </v-row>


                        <br>
                        <br>
                        <v-row form class="form-group">
                            <label class="col-form-label">
                                تاریخ
                            </label>
                            <div>
                                <date-picker
                                        editable
                                        :auto-submit="true"
                                        v-model="model.date"
                                        display-format="jYYYY/jMM/jDD"
                                        format="YYYY-MM-DD"
                                ></date-picker>
                            </div>
                        </v-row>
                        <br>

                        <v-text-field
                            dense
                            v-model="model.price"
                                id="price"
                                @keypress="isNumber"
                                suffix="ریال"
                                v-on:keyup.enter="another_focus('summary')"
                                label="مبلغ"/>
                        <v-text-field
                            dense
                            id="summary"
                                v-model="model.summary"
                                v-on:keyup.enter="another_focus('add_pre_payment')"
                                label="توضیحات"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0"  color="success" id="add_pre_payment" @click="insert_data()">
                            ثبت
                        </v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="add_pre_payment" @click="insert_data()">
                            ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { bus } from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

    export default {
        name: 'OriginDownload',
        components: {
            Treeselect,
            datePicker: VuePersianDatetimePicker
        },
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                status_form: 0,
                trucks: [],

                model: {
                    selected_truck: null,
                    price: '',
                    date: '',
                    summary: '',

                },
                headers: [
                    {
                        text: 'کد',
                        value: 'id'
                    },
                    {
                        text: 'کد کامیون',
                        value: 'truck_code'
                    },
                    {
                        text: 'نام کامیون',
                        value: 'truck_name'
                    },
                    {
                        text: 'تاریخ پرداخت',
                        value: 'persian_date'
                    },
                    {
                        text: 'مبلغ پرداختی',
                        value: 'price'
                    },
                    {
                        text: 'توضیحات',
                        value: 'summary'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ],

                normalizer_truck (node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },

            }
        },
        mounted () {
            this.get_data()
            this.get_trucks()
            this.model.date = this.get_today()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        methods: {
            reset_form () {
                this.model = {
                    selected_truck: null,
                    price: '',
                    summary: '',
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = item
                this.model.selected_truck = parseInt(item.truck_id)
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/pre_payment/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/pre_payment/insert'
                if (this.status_form != 0) {
                    url = '/api/pre_payment/update'
                    formData.append('id', this.status_form)
                }
                formData.append('truck_id', this.model.selected_truck)
                formData.append('date', this.model.date)
                formData.append('price', this.model.price)
                formData.append('summary', this.model.summary)

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog (item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id

            },
            delete_item () {
                const self = this
                const formData = new FormData()
                const url = '/api/pre_payment/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_trucks () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.trucks = response.data.data
                        self.trucks.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
        }
    }
</script>
